import styled from "styled-components";

const FoooterWrapper = styled.footer`
  min-width: 1200px;
  width: 100%;
  height: 120px;
  background-color: #0f0f0f;
  box-sizing: border-box;

  @media (max-width: 426px) {
    min-width: 100%;
    box-sizing: border-box;
    padding: 20px 0px 34px 16px;
    height: 80px;
  }
`;

function Footer() {
  return (
    <footer>
      <FoooterWrapper></FoooterWrapper>
    </footer>
  );
}

export default Footer;
